// Ported from crew-app v1 (src/helpers/setStyleProperties.ts) so both apps
// apply organization branding the same way.

type RestoreFunction = () => void
type StyleProperties = Record<string, string | null>

export const setStyleProperties = (
  element: HTMLElement,
  props: StyleProperties,
): RestoreFunction => {
  const setProperties = (toSet: StyleProperties) => {
    for (const [key, value] of Object.entries(toSet)) {
      element.style.setProperty(key, value)
    }
  }

  const previousProperties = Object.keys(props).reduce((collect, key) => {
    collect[key] = element.style.getPropertyValue(key) ?? null
    return collect
  }, {} as StyleProperties)

  setProperties(props)
  return () => {
    setProperties(previousProperties)
  }
}
